// Styled components
import { SmallerBlockStyled } from "../ViewStats.styled";
import { Typography } from "../../../../components/Typography";
import { BoxLoader } from "../../../../components";

const SmallerBlock = ({ count, title, subtitle, isLoading, highlight }) => {
  return (
    <SmallerBlockStyled highlight={highlight}>
      <Typography tag="p" nomargin fontSize="13" bold mb="10">
        {title}
      </Typography>
      {isLoading ? (
        <div style={{ width: 35, height: 35 }}>
          <BoxLoader tiny />
        </div>
      ) : (
        <Typography tag="p" nomargin fontSize="30" bold mb="10">
          {count}
        </Typography>
      )}
      <Typography tag="p" nomargin fontSize="12">
        {subtitle}
      </Typography>
    </SmallerBlockStyled>
  );
};

export default SmallerBlock;
